import { Box, Container } from "@mui/material";
import type { ReactNode } from "react";
import Footer from "./main/Footer/Footer";
import Header from "./main/Header/Header";
import AppDrawer from "./main/Header/Drawer/AppDrawer";
import Loading from "./ui/Loading/Loading";
import ScrollProgressIndicator from "../common/ScrollProgressIndicator";

interface LayoutProps {
  children?: ReactNode;
}

function Layout({ children }: LayoutProps) {
  return (
    <Box width={"100%"}>
      <ScrollProgressIndicator />
      <Loading />
      <Header />
      <Box width={"100%"} minHeight={{ xs: "93vh", md: "93.5vh" }}>
        <Box minHeight={45} id={"perfil"} />
        <Box component={"main"} py={1}>
          <AppDrawer />
          <Container>{children}</Container>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

export default Layout;
